const yup = require("yup");
const uniCodeValidRegex =
  /(^[\p{L}\p{N}\p{P}\p{Z}]*[^<>\[\]{}|\\\^~;$?\*&]+)+$/;

export const fieldEditSchema = (name, dangerousCharAllowed = false) =>
  dangerousCharAllowed
    ? yup
        .object({
          [name]: yup.string().max(255, "Maximum 255 characters allowed"),
        })
        .noUnknown(true)
    : yup
        .object({
          [name]: yup
            .string()
            .matches(uniCodeValidRegex, "Invalid characters present")
            .max(255, "Maximum 255 characters allowed"),
        })
        .noUnknown(true);

export const fieldEditSchemaMulti = (name, dangerousCharAllowed = false) =>
  dangerousCharAllowed
    ? yup
        .object({
          [name]: yup.string().max(10000, "Maximum 10000 characters allowed"),
        })
        .noUnknown(true)
    : yup
        .object({
          [name]: yup.string().max(10000, "Maximum 10000 characters allowed"),
        })
        .noUnknown(true);

export const addDataSchema = (keys, dangerousCharAllowed = false) =>
  dangerousCharAllowed
    ? yup
        .object(
          keys.reduce((acc, key) => {
            acc[key] = yup.string().max(255, "Maximum 255 characters allowed");
            return acc;
          }, {}),
        )
        .noUnknown(true)
    : yup
        .object(
          keys.reduce((acc, key) => {
            acc[key] = yup
              .string()
              .matches(uniCodeValidRegex, "Invalid characters present")
              .max(255, "Maximum 255 characters allowed");
            return acc;
          }, {}),
        )
        .noUnknown(true);

export const addDataSchemaMulti = (keys, dangerousCharAllowed = false) =>
  dangerousCharAllowed
    ? yup
        .object(
          keys.reduce((acc, key) => {
            acc[key] = yup
              .string()
              .max(10000, "Maximum 10000 characters allowed");
            return acc;
          }, {}),
        )
        .noUnknown(true)
    : yup
        .object(
          keys.reduce((acc, key) => {
            acc[key] = yup
              .string()
              .matches(uniCodeValidRegex, "Invalid characters present")
              .max(10000, "Maximum 10000 characters allowed");
            return acc;
          }, {}),
        )
        .noUnknown(true);
